import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type HSMRegularKekObj } from '../services/regularKekService'

export interface RegularKekListState {
  isLoading: boolean
  error: string | null
  httpStatus: number | null
  regularKekList: HSMRegularKekObj | null
}

const initialState: RegularKekListState = {
  isLoading: false,
  error: null,
  httpStatus: 0,
  regularKekList: null
}

const regularKekListSlice = createSlice({
  name: 'regularKekList',
  initialState,
  reducers: {
    regularKekListLoadingAction: (state) => {
      return {
        isLoading: true,
        error: null,
        httpStatus: 0,
        regularKekList: null
      }
    },
    regularKekListUpdateAction: (state, action: PayloadAction<{ data: HSMRegularKekObj, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: null,
        httpStatus: action.payload.httpStatus,
        regularKekList: action.payload.data
      }
    },
    regularKekListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus,
        regularKekList: null
      }
    }
  }
})

export const {
  regularKekListLoadingAction,
  regularKekListUpdateAction,
  regularKekListErrorAction
} = regularKekListSlice.actions

export default regularKekListSlice.reducer
